export default "__VITE_ASSET__DX1FDl3k__"